import { createSlice } from "@reduxjs/toolkit";

export const teamMemberSlice = createSlice({
  name: "teamMember",
  initialState: {
    getTeamMemberResult: false,
    getTeamMemberLoading: false,
    getTeamMemberError: false,
  },
  reducers: {
    teamMemberReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_TEAMMEMBER":
          return {
            ...state,
            getTeamMemberResult: payload.data,
            getTeamMemberLoading: payload.loading,
            getTeamMemberError: payload.error,
          };
        default:
          return state;
      }
    },
  },
});

export const { teamMemberReducers } = teamMemberSlice.actions;

export default teamMemberSlice.reducer;
